import React from 'react';
import styles from './Icon.module.css'

export const ExitIcon = () => (
    <div className={styles.icon}>
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M15 16V22H4V2L15 2V8' stroke='white' strokeWidth='2' />
            <path d='M19 8.5L22 10.5V13.5L19 15.5' stroke='white' strokeWidth='2' />
            <path d='M12 12H19' stroke='white' strokeWidth='2' />
        </svg>
    </div>
);
